// @flow
import * as React from 'react';

type HeaderMenuContextType = {
  mainMenuOpen: boolean,
  setMainMenuOpen: (boolean | (boolean => boolean)) => void,
  burgerRef: { current: null | HTMLButtonElement },
};

export const HeaderMenuContext: React.Context<HeaderMenuContextType> =
  React.createContext<HeaderMenuContextType>({
    mainMenuOpen: false,
    setMainMenuOpen: () => {},
    burgerRef: { current: null },
  });
